import SkillSuggestion from './model';
import create from './create';

SkillSuggestion.create = create;
export default SkillSuggestion;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/Suggestions/SkillSuggestion/index.js